/* eslint-disable no-magic-numbers , complexity */
import { TRACKING_EVENTS } from '@futrli/predict/core/constants';
import { trackEvent } from '@futrli/predict/core/tracker';
import { FinData } from '@futrli/predict/report-builder/types';

import { ForecastType, OrgOrConForecastListItem } from '../types';

/**
 * Sends a forecast creation tracking event
 * @param forecastType - the type of the new forecast (E.G: budget)
 */
export const trackCreateForecastEvent = (forecastType?: ForecastType, isConsolidated?: boolean) => {
  if (!forecastType) {
    return;
  }

  trackEvent(TRACKING_EVENTS.CREATED_ANY_FORECAST);

  if (isConsolidated) {
    trackEvent(TRACKING_EVENTS.CREATE_CONSOLIDATION_FORECAST);
  } else {
    if (forecastType === ForecastType.BUDGET) {
      trackEvent(TRACKING_EVENTS.CREATED_1_YR_P_L);
    }
    if (forecastType === ForecastType.SCENARIO) {
      trackEvent(TRACKING_EVENTS.CREATED_3_YR_CASH_FLOW);
    }
    if (forecastType === ForecastType.SCENARIO_WITH_INVOICES) {
      trackEvent(TRACKING_EVENTS.CREATED_3_YR_CASH_FLOW_INVOICES);
    }
  }
};

/**
 * Sends a forecast creation tracking event based on the given forecast kind and includeInvoices values.
 * It will not send a tracking request if the kind is an empty string.
 * @param forecastType - the 'kind' of the new forecast (E.G: budget)
 * @param isConsolidated - whether the forecast is a consolidated forecast or not
 */
export const trackDuplicateForecastEvent = (kind: string, includeInvoices: boolean, isConsolidated: boolean) => {
  if (kind) {
    if (kind === 'budget') {
      trackCreateForecastEvent(ForecastType.BUDGET, isConsolidated);
    } else {
      if (includeInvoices) {
        trackCreateForecastEvent(ForecastType.SCENARIO_WITH_INVOICES, isConsolidated);
      } else {
        trackCreateForecastEvent(ForecastType.SCENARIO, isConsolidated);
      }
    }
  }
};

/**
 * Returns chart values from fin data response
 */
export const getChartValues = (
  f: OrgOrConForecastListItem,
  comparisonMetric: string,
  financialData?: Record<string, FinData>
) => {
  const values = (Array.isArray(financialData?.[f.id]?.fields[comparisonMetric])
    ? financialData?.[f.id]?.fields[comparisonMetric]
    : Array.isArray(financialData?.[f.id]?.fields[comparisonMetric]?.values)
    ? financialData?.[f.id]?.fields[comparisonMetric].values
    : []) as string[];
  return values;
};

export const getPeriodCount = (period: string) => {
  switch (period) {
    case 'monthly':
      return 13;
    case 'daily':
      return 366;
    case 'quarterly':
      return 13;
    case 'weekly_sun':
    case 'weekly_mon':
      return 53;
    default:
      return 4;
  }
};
